// Brand-related translations
const brandsTranslations = {
    brand_status: {
        th: "สถานะ",
        en: "Status",
        ja: "ステータス",
    },
    brand_status_draft: {
        th: "draft",
        en: "draft",
        ja: "下書き",
    },
    brand_status_editing: {
        th: "editing",
        en: "editing",
        ja: "編集中",
    },
    brand_status_released: {
        th: "released",
        en: "released",
        ja: "公開",
    },
    brand_status_duplicated: {
        th: "duplicated",
        en: "duplicated",
        ja: "重複",
    },
    brand_status_rejected: {
        th: "rejected",
        en: "rejected",
        ja: "却下",
    },
    brand_note: {
        th: "บันทึก",
        en: "Note",
        ja: "メモ",
    },
};

export { brandsTranslations };
